
const PageSelector = ({ pageState, onPageChange }) => {
    const { page, pages } = pageState
    const maxPagesToShow = 7;

    const handlePrevious = () => {
        if (page > 1) {
            onPageChange(page - 1);
        }
    };

    const handleNext = () => {
        if (page < pages) {
            onPageChange(page + 1);
        }
    };

    const handlePageClick = (page) => {
        onPageChange(page);
    };

    const renderPageNumbers = () => {
        const totalPages = [];
        if (pages <= maxPagesToShow) {
            // Show all pages if totalPages is less than or equal to maxPagesToShow
            for (let i = 1; i <= pages; i++) {
                totalPages.push(
                    <button
                    key={i}
                    onClick={() => handlePageClick(i)}
                    className={`px-3 py-1 mx-1 rounded cursor-pointer ${page === i ? 'bg-[#C1C1C1] text-white' : 'bg-[white] text-black'
                    }`}
                    >
                        {i}
                    </button>
                );
            }
        } else {
            // Calculate the range of pages to show
            const leftBound = Math.max(2, page - 2);
            const rightBound = Math.min(pages - 1, page + 2);
            
            
            // Always show the first page
            totalPages.push(
                <button
                key={1}
                onClick={() => handlePageClick(1)}
                className={`px-3 py-1 mx-1 rounded cursor-pointer ${page === 1 ? 'bg-[#C1C1C1] text-white' : 'bg-[white] text-black'
                }`}
                >
                    1
                </button>
            );
            
            // Add ellipsis after the first page if needed
            if (leftBound > 2) {
                totalPages.push(<span key="left-ellipsis" className="px-3 py-1 mx-1">...</span>);
            }
            
            // Show pages around the current page
            for (let i = leftBound; i <= rightBound; i++) {
                totalPages.push(
                    <button
                    key={i}
                    onClick={() => handlePageClick(i)}
                    className={`px-3 py-1 mx-1 rounded cursor-pointer ${page === i ? 'bg-[#C1C1C1] text-white' : 'bg-[white] text-black'
                    }`}
                    >
                        {i}
                    </button>
                );
            }
            
            // Add ellipsis before the last page if needed
            if (rightBound < pages - 1) {
                totalPages.push(<span key="right-ellipsis" className="px-3 py-1 mx-1 text-black">...</span>);
            }
            
            // Always show the last page
            totalPages.push(
                <button
                    key={totalPages}
                    onClick={() => handlePageClick(pages)}
                    className={`px-3 py-1 mx-1 rounded cursor-pointer ${page === pages ? 'bg-[#C1C1C1] text-white' : 'bg-[white] text-black'
                        }`}
                >
                    {pages}
                </button>
            );
        }
        return totalPages;
    };

    return (
        <div className="flex items-center justify-center space-x-2">
            <button
                onClick={handlePrevious}
                disabled={page === 1}
                className="px-3 py-1 bg-[#007b4e] text-white rounded hover:opacity-80 disabled:opacity-50"
            >
                &larr;
            </button>
            {renderPageNumbers()}
            <button
                onClick={handleNext}
                disabled={page === pages}
                className="px-3 py-1 bg-[#007b4e] text-white rounded hover:opacity-80 disabled:opacity-50"
            >
                &rarr;
            </button>
        </div>
    );
};

export default PageSelector;